import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { STORAGE_KEYS } from 'src/app/constants/storage-keys';
import { SupplierOrders } from 'src/app/models/supplier-portal/supplier/supplierOrders.models';
import { OrderSupplierService } from 'src/app/services/portal-supplier/order-supplier.service';

@Component({
  selector: 'app-gamma-orders',
  standalone: false,
  templateUrl: './gamma-orders.component.html',
  styleUrls: ['./gamma-orders.component.scss'],
})
export class GammaOrdersComponent implements OnInit {
  @Input() public orderNumber: string = '';
  @Output() public readonly closed = new EventEmitter<void>();

  public readonly pageSize = 20;
  public readonly rowHeight = 44;
  public orderService = inject(OrderSupplierService);
  private Payload: SupplierOrders.IAddNewOrderFromGamma;
  public ordersFromGammaResponse: SupplierOrders.ResponseOrderFromGamma =
    new SupplierOrders.ResponseOrderFromGamma(null);

  gammaOrders: any[] = []; // Replace with actual type when available

  constructor() { }
  public close(): void {
    this.closed.emit();
  }
  ngOnInit(): void {
    console.log('OrderNumber is', this.orderNumber);
    const supplierAccount = this.orderService.suplierDetails;
    if (!supplierAccount) {
      this.close();
      return;
    }
    if (!this.orderNumber) {
      this.close();
      return;
    }

    this.Payload = {
      supplier_id: supplierAccount?.supplier?.supplier_id,
      supplier_code: supplierAccount?.supplier?.code,
      order_number: this.orderNumber,
    };

    if (this.Payload) this.addNewOrderAkaSearch(this.Payload);
  }

  addNewOrderAkaSearch(payload: SupplierOrders.IAddNewOrderFromGamma): void {
    this.orderService.addNewOrder(payload).subscribe((response) => {
      console.log('Response from addNewOrder', response);
      if (!response) return;
      // this.ordersFromGammaResponse = response;

      // localStorage.setItem(
      //   STORAGE_KEYS.GAMMA_ORDER_RESPONSE,
      //   JSON.stringify(this.ordersFromGammaResponse),
      // );
      // Handle the response as needed, e.g., update the UI or show a message
    });
  }
}
